import Challenges from './Challenges/Challenges'
import HeaderSection from './HeaderSection/HeaderSection'
import Mission from './Mission/Mission'
import Curriculum from './Curriculum/Curriculum'
import End from './End/End'
import SimpleMenu from './SimpleMenu/SimpleMenu'
import Loading from './Loading/Loading'
import AsideThumbBanner from './AsideThumbBanner/AsideThumbBanner'
import TestimonialsBanner from './TestimonialsBanner/TestimonialsBanner'
import MediumGrid from './MediumGrid/MediumGrid'
import LargeGrid from './LargeGrid/LargeGrid'
// import Speak from './Speak/Speak'
import Footer from './Footer/Footer'

export {
	Challenges,
	Mission,
	HeaderSection,
	Curriculum,
	End,
	Footer,
	SimpleMenu,
	Loading,
	AsideThumbBanner,
	TestimonialsBanner,
	MediumGrid,
	LargeGrid
}



// WEBPACK FOOTER //
// ./src/client/website/components/index.js